var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafety(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEA832"
    },
    d: "M482,316v105H30V316c0-73.5,36.4-138.6,91-179.7l15,44.7l15-63.9C182.5,100.6,218.2,91,256,91 s73.5,9.6,105,26.1l15,63.9l15-44.7C445.6,177.4,482,242.5,482,316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE9923"
    },
    d: "M482,316v105H256V91c37.8,0,73.5,9.6,105,26.1l15,63.9l15-44.7C445.6,177.4,482,242.5,482,316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEDB41"
    },
    d: "M331,106v150c0,8.399-6.599,15-15,15H196c-8.401,0-15-6.601-15-15V106c0-24.901,20.099-45,45-45h60 C310.901,61,331,81.099,331,106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCBF29"
    },
    d: "M376,241c8.291,0,15-6.709,15-15v-89.692c-9.481-7.136-19.438-13.649-30-19.235V226 C361,234.291,367.709,241,376,241z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEDB41"
    },
    d: "M136,241c8.291,0,15-6.709,15-15V117.072c-10.562,5.587-20.519,12.1-30,19.235V226 C121,234.291,127.709,241,136,241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEDB41"
    },
    d: "M512,421c0,16.5-13.5,30-30,30H30c-16.5,0-30-13.5-30-30s13.5-30,30-30h452 C498.5,391,512,404.5,512,421z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCBF29"
    },
    d: "M316,271h-60V61h30c24.901,0,45,20.099,45,45v150C331,264.399,324.401,271,316,271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCBF29"
    },
    d: "M512,421c0,16.5-13.5,30-30,30H256v-60h226C498.5,391,512,404.5,512,421z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.3cf50e92.svg";
export { ForwardRef as ReactComponent };